import React, { useEffect } from "react";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { FaArrowRight, FaBalanceScale } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useSelector } from "react-redux";

const services = [
  {
    name: "Platform Gestion",
    image: "/images/other-services/pgestion.png",
    features: [
      "Montage de vos factures",
      "Montage de vos devis",
      "Secrétariat personnalisé",
      "ERP Gestion 100% cloud",
    ],
  },
  {
    name: "Platform Admin",
    image: "/images/other-services/padmin.png",
    features: [
      "Télédéclaration d'impôts",
      "Déclaration statistique et fiscale (DSF)",
      "Cotisation sociale",
    ],
  },
  {
    name: "Platform Client",
    image: "/images/other-services/sale.png",
    features: [
      "Suivi Client via ERP",
      "Relance clients",
      "Gestion de la relation client",
      "Relances règlement",
    ],
  },
  {
    name: "Platform GRH",
    image: "/images/other-services/pgrh.png",
    features: [
      "Gestion des contrats",
      "Bulletins de paie",
      "Assistance Rupture Contrats",
    ],
  },
  {
    name: "Platform Juridique",
    icon: <FaBalanceScale size={50} color="#051259" />,
    features: [
      "Suivis contentieux professionnel",
      "Contrats d’affaires",
      "Secrétariat juridique",
    ],
  },
];

function OtherServices() {
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const currentStep = "Services";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleSkipClick = () => {
    navigate("/cart");
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "50px" }}>
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />

      {/* Intro Section */}
      <div className="container mt-4 text-center" style={{ maxWidth: "850px" }}>
        <h4 className="text-2xl font-semibold">
          Après la création de votre entreprise, arrive l’étape essentielle :{" "}
          <span style={{ color: "#FF5500" }}>la gestion</span>.
        </h4>
        <p style={{ color: "#555", fontSize: "16px", lineHeight: "1.5" }}>
          Nous vous proposons une gamme de services pour gérer efficacement
          votre entreprise : comptabilité, déclarations fiscales, secrétariat,
          ressources humaines et suivi juridique.
        </p>
      </div>

      {/* Services Slider */}
      <Container className="mt-5">
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={20}
          slidesPerView={4}
          navigation
          pagination={false}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1440: { slidesPerView: 4 },
          }}
        >
          {services.map((service, index) => (
            <SwiperSlide key={index} style={{ justifyItems: "center" }}>
              <div
                className="service-box"
                style={{
                  borderRadius: "16px",
                  backgroundColor: "#fff",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  padding: "24px",
                  height: "100%",
                  minHeight: "280px",
                  width: "300px",
                  display: "flex",
                  flexDirection: "column",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  cursor: "pointer",
                  marginBottom: "10px",
                }}
              >
                <div className="text-center mb-3">
                  {service.image ? (
                    <img
                      src={service.image}
                      alt={service.name}
                      className="img-fluid"
                      style={{ height: "60px", objectFit: "contain" }}
                    />
                  ) : (
                    service.icon
                  )}
                </div>
                <h6 className="fw-bold text-center mb-3">{service.name}</h6>
                <ul
                  className="list-unstyled mt-1"
                  style={{ justifyItems: "start" }}
                >
                  {service.features.map((feature, idx) => (
                    <li
                      key={idx}
                      className="d-flex align-items-start mb-2"
                      style={{ fontSize: "13px", lineHeight: "1.2" }}
                    >
                      <span style={{ color: "#28a745", marginRight: "8px" }}>
                        ✔
                      </span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>

      {/* Call to Action */}
      <div className="container text-center mt-4">
        <Button
          className="btn"
          style={{
            backgroundColor: "#051259",
            color: "#fff",
            borderRadius: "10px",
            padding: "12px 28px",
            fontSize: "16px",
          }}
          onClick={() => {
            if (
              cart?.businessCountry === "CM" ||
              cart?.company?.country === "CM"
            ) {
              navigate("/platform-admin");
            } else {
              navigate("/platform-juridique");
            }
          }}
        >
          Découvrir les services
          <FaArrowRight style={{ marginLeft: "10px" }} />
        </Button>

        <div className="container text-center mt-3">
          <span
            onClick={handleSkipClick}
            style={{ color: "#3392FF", cursor: "pointer" }}
          >
            Pas maintenant, peut-être plus tard.
          </span>
        </div>
      </div>
    </div>
  );
}

export default OtherServices;
